import { render, staticRenderFns } from "./loanFollowup.vue?vue&type=template&id=bb19d41a&scoped=true&"
import script from "./loanFollowup.vue?vue&type=script&lang=js&"
export * from "./loanFollowup.vue?vue&type=script&lang=js&"
import style0 from "./loanFollowup.vue?vue&type=style&index=0&id=bb19d41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb19d41a",
  null
  
)

export default component.exports